import { DownOutlined } from '@ant-design/icons';
import { Button, Dropdown } from 'antd';
import PropTypes from 'prop-types';

/**
 * Shared Dropdown + primary Button with DownOutlined. Used by BookedButtons, FinishedButtons, WaitingBookingButtons.
 * @component
 * @param {Object} props - The component props.
 * @param {React.ReactNode} props.overlay - The overlay to display when the button is clicked.
 * @param {React.ReactNode} props.label - The label to display on the button.
 * @returns {JSX.Element} The DropdownMenuButton component.
 */
export const DropdownMenuButton = ({ overlay, label }) => (
  <Dropdown overlay={overlay}>
    <Button type="primary">
      {label}
      <DownOutlined />
    </Button>
  </Dropdown>
);

DropdownMenuButton.propTypes = {
  overlay: PropTypes.node.isRequired,
  label: PropTypes.node.isRequired
};
